<template>
  <div class="login" v-loading="qyloading">
    <div class="login_con_top">
      <div class="login_con">
        <div class="m-login-panel">
          <div class="thisbind">
            <H2>手机号码绑定</H2>
            <div class="login_con_pub">
              <div class="login_con_pub_info login_con_pub_name">
                <el-input type="text" v-model="formData.tel" placeholder="请输入手机号码" maxlength="11"></el-input>
              </div>
            </div>
            <div class="login_con_pub">
              <div class="login_con_pub_info login_con_pub_phone clearfix">
                <el-input v-model="formData.telCode" placeholder="手机验证码" maxlength="11"></el-input>
                <a href="javascript:;" v-show="codeType" @click="sendCode">发送手机验证码</a>
                <a href="javascript:;" v-show="!codeType" >{{ count }}s</a>
              </div>
            </div>
            <a class="login_con_loginbtn" href="javascript:;" v-if="!inputShow" @click="sureBind">
              确&emsp;&emsp;定
            </a>
            <div class="login_wjmm clearfix">
              <div class="wjmm_btn" @click="reToken(1)">返回首页</div>
              <div class="reg_btn" @click="reToken(2)">登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sendSMS, bindTelst } from '@/api/login'

import { removeToken } from '@/utils/auth'

export default {
  name: 'Bindtel',
  data () {
    return {
      formData: {
        tel: '',
        telCode: ''
      },
      qyloading: false,
      inputShow: false,
      codeType: true,
      count: ''
    }
  },
  mounted () {

  },
  methods: {
    sureBind () {
      if (!this.formData.tel) {
        this.$message.error('请输入手机号码')
        return false
      }
      if (!this.formData.telCode) {
        this.$message.error('请输入手机验证码')
        return false
      }
      var wxUser = JSON.parse(localStorage.getItem('wxMsg'))
      this.formData.wx_user_id = wxUser.id
      bindTelst(this.formData).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch('user/saveInformation', res).then(() => {
            localStorage.removeItem('wxMsg')
            this.$router.push({ path: '/' })
          })
        }
      })
    },
    sendCode () {
      const regs = /^1[3|4|5|7|8][0-9]\d{8}$/
      if (!this.formData.tel || !regs.test(this.formData.tel)) {
        this.$message.error('请输入正确的手机号码')
        return false
      }
      sendSMS({tel: this.formData.tel}).then(res => {
        const TIME_COUNT = 60
        if (!this.timer) {
          this.count = TIME_COUNT
          this.codeType = false
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
            } else {
              this.codeType = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
      })
    },
    reToken (num) {
      removeToken()
      localStorage.removeItem('wxMsg')
      if (num === 1) {
        this.$router.push({ path: '/' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    }
  }
}
</script>
<style scoped>
.thisbind{
  width: 350px;
  display: inline-block;
}
.login_con_top{
  width:100%;
  background: url(../../assets/images/bindtel1.jpg) no-repeat center / 100% 100%;
}
.login_con{
  margin: 180px 0 0 0px;
  width: 100%;
  opacity: 0.8;
}
.login_con_loginbtn {
  width: 350px;
}
.m-login-panel {
  overflow: hidden;
  padding: 30px 25px;
  background-color: #fff;
  position: relative;
  min-height: 340px;
  border: 1px solid #eceded;
  box-shadow: 0px 10px 12px 0px rgb(0 55 156 / 15%);
  text-align: center;
}
.login_con_pub{
  margin-top: 30px;
  width:350px;
  display: inline-block;
}
.login_con_pub_info.login_con_pub_name{
  background-size: 18px;
}
.login_con_pub_info input{
  height: 30px !important;
  line-height: 30px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/view/login/bindtel.vue